export default __webpack_public_path__ + "static/media/Image-15.ed676656.png";